<template>
  <div class="page">
    <ActionBar :breadcrumbItems="breadcrumbItems">
      actions
    </ActionBar>

    <div class="page--content">
      UsagePoliciesPage
    </div>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'
import ActionBar from 'components/Actionbar'

export default {
  name: 'UsagePoliciesPage',
  components: {
    ActionBar
  },
  data () {
    return {
      breadcrumbItems: [
        { title: this.$t('Common.settings') },
        { name: 'UsagePolicies', title: this.$t('Views.UsagePoliciesPage.title') }
      ]
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
